mutation UpdateMessages($input: MessageUpdateInput!) {
  messageUpdate(input: $input) {
    clientMutationId
  }
}
